import type Article from "@gik/blog/models/Article";
import { useBemCN } from "@gik/core/utils/bemBlock";
import { ArticleHeader } from "@gik/ui-legacy/gik/ArticleTile";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import React from "react";

export interface IArticleHeaderSectionProps {
	article: Article;
	className?: string;
}

const blockName = "article-header-section";

export function ArticleHeaderSection({
	article,
	className,
}: IArticleHeaderSectionProps) {
	const bem = useBemCN(blockName);

	return (
		<PageSection {...bem(null, null, className)}>
			<ArticleHeader {...bem("article-header")} article={article} />
		</PageSection>
	);
}
